module.exports = __webpack_public_path__ + "img/logo_revista_np_grande.07f9489f.png";